import { z } from "zod";
import { Id, IsoDateTime } from "./common.ts";

/** A venue "session" = one operating night/shift during which check-ins happen. */
export const SessionStatus = z.enum(["scheduled", "open", "last_call", "closing", "closed"]);
export type SessionStatus = z.infer<typeof SessionStatus>;

export const Session = z.object({
  id: Id,
  venueId: Id,
  label: z.string().min(1),
  status: SessionStatus,
  openedAt: IsoDateTime.optional(),
  closedAt: IsoDateTime.optional(),
  createdAt: IsoDateTime,
});
export type Session = z.infer<typeof Session>;
